import type { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import { extractApiError } from '@/shared/lib/api/extractError';

import { activityApi } from '../api/activityApi';
import { activityActions } from './slice';
import type { ActivityItem } from './types';

function* fetchActivitySaga(
  action: PayloadAction<{ offset: number; limit: number }>,
): Generator {
  try {
    const { offset, limit } = action.payload;
    const items = (yield call(activityApi.getActivity, limit, offset)) as ActivityItem[];
    yield put(activityActions.fetchActivitySuccess({ items, limit }));
  } catch (err) {
    yield put(activityActions.fetchActivityFailure(extractApiError(err)));
  }
}

export function* activityWatcher(): Generator {
  yield takeLatest(activityActions.fetchActivityRequest.type, fetchActivitySaga);
}
